// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../Faraz.React/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label.sf-remember-me input[type=checkbox] {\r\n    margin: 0;\r\n    vertical-align: middle;\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
